import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Lms } from 'app/shared/models/lms';
import { StrapiApiService } from 'app/shared/services/strapi-api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'lms-list',
  templateUrl: './lms-list.component.html',
  styleUrls: ['./lms-list.component.scss']
})
export class LmsListComponent implements OnInit {

  // row data
  searchTerm = new FormControl('');
  rows: Lms[];
  selectedValue = ''
  term: string = ''
  p = 1
  collection: any;
  selectedTags: any = [];
  searches: any = [];
  searchesCollection: any = {
    rb_collections: []
  };
  password: any = '';
  count: any;
  rbc: any;
  pageSize = 9;
  currentPage = 0;
  pageNo = 0;
  contentLength: any;
  modelFormat: any;

  constructor(private router: Router,
    public toastr: ToastrService,
    private apiService: StrapiApiService
  ) {
    // if (localStorage.getItem('pt')) {
    //   localStorage.removeItem('pt');
    // }
  }

  getLmsV1(page) {
   let query =`(limit:${this.pageSize},start:${page})`
    this.apiService.getLmsV1(query).subscribe((res: any) => {
      this.rows = res;
    })
  }
  getCount() {
    this.apiService.getCount('lms-v-1-s').subscribe((res: any) => {
      this.count = res;
    })
  }

  // searchTag(key) {
  //   this.apiService.searchTags(key).subscribe((res: any) => {
  //     this.searches = res;
  //   })
  // }

  // selectSearchedOption(item) {
  //   const index: number = this.selectedTags.findIndex(tag => {
  //     return tag.id === item.id
  //   });
  //   if (index === -1) {
  //     this.selectedTags.push(item);
  //   }
  //   else {
  //     this.selectedTags.splice(index, 1);
  //   }
  // }
  // ------------------------------------------------reset searchTags  -------------------------------------------
  // resetTag() {
  //   this.searchesCollection.rb_collections = ''
  //   this.selectedTags = []
  //   this.term = ''
  // }
  // ------------------------------------------------searchCollections by text  -------------------------------------------
  // searchCollections() {
  //   let filter = ``;
  //   let i = 1;
  //   let j = 2;
  //   let t = 0
  //   let tagname;
  //   let content = ``
  //   for (let name of this.selectedTags) {
  //     tagname = `&_where[_or][${t}][rb_tags.name]=${name.name}`
  //     filter += tagname;
  //     t++
  //   };
  //   for (i = 1; i <= this.contentLength; i++, j++) {
  //     content += `&_where[_or][${j}][content_${i}_contains]=${this.term}`
  //   }
  //   if (this.term) {
  //     this.apiService.searchText(this.term, content, filter).subscribe((res: any) => {
  //       this.searchesCollection.rb_collections = res
  //       if (!this.searchesCollection.rb_collections.length) {
  //         this.toastr.info('No data found')

  //       }
  //     });
  //   }
  // }

  selectTag(data: any) {
      var name = data.title;
      name = name.toLowerCase();
      name = name.replace(/ /g, "-");
      name = name.replace(/\?/g, "-");
      this.router.navigate([`/lms/detail/${name}`, data.id])
  }

  ngOnInit() {
    this.getLmsV1(this.pageNo);
    this.getCount();
    // this.searchTerm.valueChanges.subscribe(value => {
    //   value == '' ? this.searches = [] : this.searchTag(value)
    // })
  }

  pageChange(pageNo?) {
    let checkPage = 0
    if (pageNo > checkPage) {
      pageNo = pageNo - 1;
      this.pageNo = pageNo * this.pageSize;
      this.getLmsV1(this.pageNo)
      checkPage = pageNo;
    } if (pageNo < checkPage) {
      this.pageNo = this.pageNo / this.pageSize;
      this.getLmsV1(this.pageNo)
    }
  }
}
